import { ChangeDetectionStrategy, Component, booleanAttribute, input, output } from '@angular/core';
import { IChingMethodSteps } from '../../core/iching.models';
import { HdIChingHexagramFigureComponent } from '../../figure/hd-iching-hexagram-figure.component';
import { injectIChingTranslate } from '../iching-consult-translate';

/**
 * Introductie bovenaan de raadpleegpagina: wat de I Tjing is, met een
 * voorbeeldhexagram als illustratie. Inklapbaar; de keuze bewaart de ouder
 * in de settings (`ichingIntroCollapsed`).
 */
@Component({
  selector: 'hd-iching-intro',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HdIChingHexagramFigureComponent],
  styles: `
    :host { display: block; }
    .intro {
      padding: 14px 16px; border-radius: var(--radius-md, 6px);
      background: var(--hd-iching-card-bg, rgba(0, 0, 0, 0.035));
    }
    .head { display: flex; align-items: center; gap: 8px; }
    .title { flex: 1 1 auto; margin: 0; font-size: 16px; }
    .toggle {
      flex: 0 0 auto; width: 32px; height: 32px; border: 0; border-radius: 50%;
      background: transparent; color: inherit; cursor: pointer;
    }
    .toggle:hover { background: rgba(0, 0, 0, 0.06); }
    .body { display: flex; gap: 20px; align-items: flex-start; margin-top: 10px; }
    .text { flex: 1 1 auto; min-width: 0; font-size: 13.5px; line-height: 1.55; }
    .text p { margin: 0 0 10px; }
    .text .purpose { font-weight: 600; }
    .figure { flex: 0 0 auto; padding-top: 4px; }
    @media (max-width: 599.98px) {
      .body { flex-direction: column-reverse; }
    }
  `,
  template: `
    <section class="intro" data-test-id="iching-intro">
      <div class="head">
        <h3 class="title">{{ intro().title }}</h3>
        <button
          type="button"
          class="toggle"
          data-test-id="iching-intro-toggle"
          [attr.aria-expanded]="!collapsed()"
          [attr.aria-label]="intro().title"
          (click)="collapsedChange.emit(!collapsed())"
        >
          <i class="fas" [class.fa-chevron-down]="collapsed()" [class.fa-chevron-up]="!collapsed()" aria-hidden="true"></i>
        </button>
      </div>
      @if (!collapsed()) {
        <div class="body">
          <div class="text">
            <!-- De bedoeling van de pagina eerst (wens Steven 2026-10-18), dan wat de I Tjing is. -->
            @for (paragraph of intro().purpose; track $index) {
              <p class="purpose" data-test-id="iching-intro-purpose">{{ paragraph }}</p>
            }
            @for (paragraph of intro().paragraphs; track $index) {
              <p>{{ paragraph }}</p>
            }
          </div>
          <hd-iching-hexagram-figure class="figure" figure="100010" [ariaLabel]="t('humanDesign.iching.page.title')" />
        </div>
      }
    </section>
  `,
})
export class HdIChingIntroComponent {
  readonly intro = input.required<IChingMethodSteps['intro']>();
  readonly collapsed = input(false, { transform: booleanAttribute });
  readonly collapsedChange = output<boolean>();

  protected readonly t = injectIChingTranslate();
}
